import { useAppSelector } from "app/store";
import { TaxType } from "common/constants";

export const useTaxType = (): string => {
  return useAppSelector((state) => state.settings.taxType) || TaxType.USETAX;
};
